import React from "react"

import {ItemModelV2_CalculatedValues} from "../../../../../../model2/item2/calculated/@type"
import ItemModelV2 from "../../../../../../model2/item2/item-model"
import TasksView_Column from "../../../../../../model2/column/column"
import FieldProto from "../../../../../proto/field-proto"

type Props = {
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto

    onMouseEnter    : callback
    onMouseLeave    : callback
}

// const debug = "FieldProgress_TableCellCalculated_NotHovered"
const debug = false

export default function FieldProgress_TableCellCalculated_NotHovered(props: Props){

    let value = 0

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
    const ownValue = calculatedValues?.own || props.field.getViewValue(props.listItem.item)

    debug && console.log(debug, "render", calculatedValues)

    if (props.listItem.view.isCollapsed && calculatedValues && !!calculatedValues?.total.value && calculatedValues.total.value != calculatedValues.own) {
        value = Math.floor(calculatedValues.total.value)
    } else if (ownValue > 0) {
        value = Math.floor(ownValue)
    }

    const showProgress = !!props.style.width && props.style.width > 70

    const excess = value > 100
    const progressLine = excess ? Math.floor(100 * (100 / value)) : value;
    const progressClasses = Classes("ui5-progress in-ui5-field", {
        'excess-v2': excess,
    });

    const progressLabelClasses = Classes("progress-label ui5-txt-less-important-small percentage txt-truncate", {
        'p-l-0': !showProgress
    })

    return (
        <div className      = "cell-flex ui5-txt-less-important-small"
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}
        >
            {!!value && (
                <div className={Classes(progressClasses, showProgress ? "" : "flex-row-left-center")}>
                    {showProgress && (
                        <div className="progress-bg">
                            <div className="progress-line" style={{width: '{0}%'.f(progressLine)}}/>
                        </div>
                    )}

                    <div className={progressLabelClasses}>
                        {"{0}%".f(value)}
                    </div>
                </div>
            )}
        </div>
    )
}



